import { c as _c } from "react/compiler-runtime";
import React, { type Dispatch, type SetStateAction } from 'react';
import { format, parseISO } from 'date-fns';
import ButtonComponent from '@spa/components/button/button/button.component';
import { ButtonType } from '@spa/components/button/types/ButtonType';
import { DetailedStore } from '../../storefinder/interfaces';
import ImageComponent from '@spa/components/image-component/image.component';
import type { ProductInfoProduct } from '../ProductInfoProductTypes';
import { de } from 'date-fns/locale';
import styles from './product-delivery-information.component.module.scss';
import useNamespacedIntl from '@spa/lib/i18n/client/hooks/useNamespacedIntl';
function formatPickupDate(dateString: string): string {
  return format(parseISO(dateString), 'dd.MM.yyyy', {
    locale: de
  });
}
function formatPickupTimeOfDay(dateString: string): string {
  return format(parseISO(dateString), 'HH:mm', {
    locale: de
  });
}
export type ClickAndCollectDeliveryInformationProps = {
  readonly isClickAndCollectAllowed: boolean;
  readonly selectedStore: DetailedStore | null;
  readonly setSelectedProduct: Dispatch<SetStateAction<ProductInfoProduct | undefined>>;
  readonly setShowStoreFinderPopup: Dispatch<SetStateAction<boolean>>;
  readonly releaseDate: string | null;
};
export const ClickAndCollectDeliveryInformation = properties => {
  const $ = _c(62);
  const {
    isClickAndCollectAllowed,
    selectedStore,
    setSelectedProduct,
    setShowStoreFinderPopup,
    releaseDate
  } = properties;
  const {
    formatMessage
  } = useNamespacedIntl("product-info");
  if (!isClickAndCollectAllowed) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <ImageComponent src="/assets/icons/info-circle.svg" height={20} width={20} alt="click and collect not available icon" className={styles["delivery-information--icon"]} />;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    let t1;
    if ($[1] !== formatMessage) {
      t1 = formatMessage("deliveryUnavailableStore");
      $[1] = formatMessage;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    let t2;
    if ($[3] !== t1) {
      t2 = <div className={styles["delivery-information--wrapper"]}>{t0}<span className={styles["delivery-information--title"]}>{t1}</span></div>;
      $[3] = t1;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    return t2;
  }
  if (selectedStore && !selectedStore.storePickUp) {
    let t0;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <ImageComponent src="/assets/icons/info-circle.svg" height={20} width={20} alt="click and collect not available icon" className={styles["delivery-information--icon"]} />;
      $[5] = t0;
    } else {
      t0 = $[5];
    }
    let t1;
    if ($[6] !== formatMessage) {
      t1 = formatMessage("deliveryTitleStore");
      $[6] = formatMessage;
      $[7] = t1;
    } else {
      t1 = $[7];
    }
    let t2;
    if ($[8] !== t1) {
      t2 = <span className={styles["delivery-information--title"]}>{t1}</span>;
      $[8] = t1;
      $[9] = t2;
    } else {
      t2 = $[9];
    }
    let t3;
    if ($[10] !== selectedStore.name) {
      t3 = <span className="bold">{selectedStore.name}</span>;
      $[10] = selectedStore.name;
      $[11] = t3;
    } else {
      t3 = $[11];
    }
    let t4;
    if ($[12] !== formatMessage) {
      t4 = formatMessage("changeStoreLinkText");
      $[12] = formatMessage;
      $[13] = t4;
    } else {
      t4 = $[13];
    }
    let t5;
    if ($[14] !== setSelectedProduct || $[15] !== setShowStoreFinderPopup) {
      t5 = () => {
        setSelectedProduct(undefined);
        setShowStoreFinderPopup(true);
      };
      $[14] = setSelectedProduct;
      $[15] = setShowStoreFinderPopup;
      $[16] = t5;
    } else {
      t5 = $[16];
    }
    let t6;
    if ($[17] !== t4 || $[18] !== t5) {
      t6 = <ButtonComponent buttonType={ButtonType.AS_TEXT} text={t4} onClick={t5} />;
      $[17] = t4;
      $[18] = t5;
      $[19] = t6;
    } else {
      t6 = $[19];
    }
    let t7;
    if ($[20] !== t3 || $[21] !== t6) {
      t7 = <div className={styles["delivery-information--store-selection"]}>{t3}{t6}</div>;
      $[20] = t3;
      $[21] = t6;
      $[22] = t7;
    } else {
      t7 = $[22];
    }
    let t8;
    if ($[23] !== formatMessage) {
      t8 = formatMessage("deliveryUnavailableStore");
      $[23] = formatMessage;
      $[24] = t8;
    } else {
      t8 = $[24];
    }
    let t9;
    if ($[25] !== t8) {
      t9 = <span>{t8}</span>;
      $[25] = t8;
      $[26] = t9;
    } else {
      t9 = $[26];
    }
    let t10;
    if ($[27] !== t7 || $[28] !== t9) {
      t10 = <div className={styles["delivery-information--content"]}>{t7}{t9}</div>;
      $[27] = t7;
      $[28] = t9;
      $[29] = t10;
    } else {
      t10 = $[29];
    }
    let t11;
    if ($[30] !== t10 || $[31] !== t2) {
      t11 = <div className={styles["delivery-information--wrapper"]}>{t0}{t2}{t10}</div>;
      $[30] = t10;
      $[31] = t2;
      $[32] = t11;
    } else {
      t11 = $[32];
    }
    return t11;
  }
  let t0;
  if ($[33] !== releaseDate) {
    t0 = !releaseDate || new Date(releaseDate) < new Date();
    $[33] = releaseDate;
    $[34] = t0;
  } else {
    t0 = $[34];
  }
  const isReleased = t0;
  let t1;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ImageComponent src="/assets/icons/check-circle-filled.svg" height={20} width={20} alt="click and collect available icon" className={styles["delivery-information--icon"]} />;
    $[35] = t1;
  } else {
    t1 = $[35];
  }
  let t2;
  if ($[36] !== formatMessage) {
    t2 = formatMessage("deliveryTitleStoreAvailable");
    $[36] = formatMessage;
    $[37] = t2;
  } else {
    t2 = $[37];
  }
  let t3;
  if ($[38] !== t2) {
    t3 = <span className={styles["delivery-information--title"]}>{t2}</span>;
    $[38] = t2;
    $[39] = t3;
  } else {
    t3 = $[39];
  }
  let t4;
  if ($[40] !== formatMessage || $[41] !== isReleased || $[42] !== selectedStore) {
    t4 = selectedStore?.pickupTime && isReleased && <span className={styles["pickup-info"]}>{formatMessage("pickupAvailableFrom", {
        date: formatPickupDate(selectedStore.pickupTime),
        time: formatPickupTimeOfDay(selectedStore.pickupTime)
      })}</span>;
    $[40] = formatMessage;
    $[41] = isReleased;
    $[42] = selectedStore;
    $[43] = t4;
  } else {
    t4 = $[43];
  }
  let t5;
  if ($[44] !== selectedStore) {
    t5 = selectedStore && <span className="bold">{selectedStore.name}</span>;
    $[44] = selectedStore;
    $[45] = t5;
  } else {
    t5 = $[45];
  }
  const t6 = selectedStore ? "changeStoreLinkText" : "selectStoreLinkText";
  let t7;
  if ($[46] !== formatMessage || $[47] !== t6) {
    t7 = formatMessage(t6);
    $[46] = formatMessage;
    $[47] = t6;
    $[48] = t7;
  } else {
    t7 = $[48];
  }
  let t8;
  if ($[49] !== setSelectedProduct || $[50] !== setShowStoreFinderPopup) {
    t8 = () => {
      setSelectedProduct(undefined);
      setShowStoreFinderPopup(true);
    };
    $[49] = setSelectedProduct;
    $[50] = setShowStoreFinderPopup;
    $[51] = t8;
  } else {
    t8 = $[51];
  }
  let t9;
  if ($[52] !== t7 || $[53] !== t8) {
    t9 = <ButtonComponent buttonType={ButtonType.AS_TEXT} text={t7} onClick={t8} />;
    $[52] = t7;
    $[53] = t8;
    $[54] = t9;
  } else {
    t9 = $[54];
  }
  let t10;
  if ($[55] !== t5 || $[56] !== t9) {
    t10 = <div className={styles["delivery-information--store-selection"]}>{t5}{t9}</div>;
    $[55] = t5;
    $[56] = t9;
    $[57] = t10;
  } else {
    t10 = $[57];
  }
  let t11;
  if ($[58] !== t10 || $[59] !== t3 || $[60] !== t4) {
    t11 = <div className={styles["delivery-information--wrapper"]}>{t1}{t3}{t4}{t10}</div>;
    $[58] = t10;
    $[59] = t3;
    $[60] = t4;
    $[61] = t11;
  } else {
    t11 = $[61];
  }
  return t11;
};